module.exports = __webpack_public_path__ + "static/media/JRA_Subsidy.f0c57e58.png";